<mat-toolbar class="main-header mat-toolbar-position">
    <div class="content-center" id="header-content">
        <div class="container-header">
            
            <div id="header-logo-bitcar">
                <a [routerLink]="['/home']">
                    <img class="main-logo" mat-image [src]="logoPrincipal" alt="logo" *ngIf="logoPrincipal !== ''" />
                </a>
            </div>


            <span class="spacer-toolbar"></span>


            <div class="container-links" fxHide.xs fxHide.sm>


                <div class="container-links-user">
                    
                    <a id="mn-faq" mat-flat-button class="monserrat-font-16" [disableRipple]="true" 
                        (click)="goToFaq()">Preguntas Frecuentes
                    </a>
                    <a id="mn-blog" mat-flat-button class="monserrat-font-16" [disableRipple]="true"
                        href="https://blog.bitcar.mx/" target="_blank" rel="noopener">
                        Blog
                    </a>
                    <ng-template #userLoginDesk>
                        <a aria-label="usuario" mat-flat-button [disableRipple]="true" (click)="login()"
                            class="monserrat-font-16 bitcar-color">
                            Iniciar Sesión
                            <mat-icon class="user-icon-before">login</mat-icon>
                        </a>
                    </ng-template>
                    <div class="user-menu" *ngIf="isLoged; else userLoginDesk">
                        <button id="header-hola" [disableRipple]="true" class="monserrat-font-16 lr-space" mat-flat-button
                            [matMenuTriggerFor]="menu">
                            Hola {{ userObject?.firstName | titlecase }}
                            <mat-icon class="user-icon">person_outline</mat-icon>
                            <span [class]="getClassCSS()" class="active-process"></span>
                        </button>
                        <mat-menu class="profile-menu" #menu="matMenu">
                            <a id="header-ultimo-paso" *ngIf="processActive && urlLocation === false"
                                [class]="getClassCSS()" class="btn-menu btn-process" mat-menu-item
                                (click)="goToLastStep()">
                                Ir al último paso
                            </a>
                            <a *ngIf="!urlComparator" id="header-comparar-autos" (click)="goComparator()" mat-menu-item>
                                Comparar autos
                            </a>
                            <a id="header-cerrar-sesion" class="btn-logout" (click)="logout()" mat-menu-item>
                                Cerrar sesión
                            </a>
                        </mat-menu>
                    </div>

                </div>

                <mat-divider></mat-divider>

                <div class="container-menu-links">

                    <a id="mn-queesbitcar" mat-flat-button class="monserrat-font-18" [disableRipple]="true" (click)="clickScroll('about')" ><b>¿Qué es BitCar?</b></a>
                    <a id="mn-comofunciona" mat-flat-button class="monserrat-font-18" [disableRipple]="true" (click)="clickScroll('how')"><b>¿Cómo funciona?</b></a>
                    <a id="mn-planes" mat-flat-button class="monserrat-font-18" [disableRipple]="true" [routerLink]="['/planes']"><b>Planes</b></a>
                    <button mat-flat-button class="btn-bitcar" [routerLink]="['/buscador']">Cotiza un auto ></button>

                </div>
            </div>


            <div fxHide.gt-sm class="container-menu-responsive">
                <button aria-label="menu" [disableRipple]="true" mat-icon-button>
                    <mat-icon svgIcon="flag-mex"></mat-icon>
                </button>
                <button aria-label="menu" [disableRipple]="true" mat-icon-button (click)="onToggleSidenav()">
                    <mat-icon>menu</mat-icon>
                    <span [class]="getClassCSS()" class="active-process"></span>
                </button>
            </div>


        </div>
    </div>
</mat-toolbar>